exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body{background-color:#fff}#print_btn{margin:30px auto;width:80px;height:40px;border-radius:4px;background-color:#63b8f8;text-align:center;line-height:40px;cursor:pointer;color:#fff}@media print{#print_btn{display:none}}\n", ""]);

// exports
